import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { crossScreenFontSize, toVw, toVwMobile, toVwTablet } from '../../../../utils/styles';
import Container from '../../../../components/Container';
import Row from '../../../../components/Row';
import Col, { COL_SIZES } from '../../../../components/ContentRows/components/Col';
import IndentSmall from '../../../../components/IndentSmall';
import Media from '../../../../components/Media';
import ResponsiveImage from '../../../../components/ResponsiveImage';
import imagePropValidation from '../../../../utils/imagePropValidation';
import mq from '@/utils/media-queries';
import { FONT_SIZE_BIG } from '../../../../constants';

const Styled = styled.div`
  padding-top: ${toVw(144)};
  padding-bottom: ${toVw(304)};
  background-color: ${props => props.theme.colorDark};
  color: #fff;

  ${mq.mobile(css`
    padding-top: ${toVwMobile(80)};
    padding-bottom: ${toVwMobile(160)};
  `)};
`;

const StyledRow = styled(Row)`
  margin-bottom: ${toVw(180)};
  display: flex;
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(80)};
  `)};
`;

const StyledCol = styled(Col)`
  ${mq.tablet(css`
    && {
      width: ${toVwTablet(480)};

      &:last-child {
        width: ${toVwTablet(337)};
      }
    }
  `)};

  ${mq.mobile(css`
    && {
      &,
      &:last-child {
        width: 100%;
      }
    }
  `)};
`;

const Text = styled.p`
  ${crossScreenFontSize(FONT_SIZE_BIG)};
`;

const StyledMedia = styled(Media)`
  width: 100%;
`;

class FeaturedHome extends React.Component {
  static propTypes = {
    photo: imagePropValidation,
    text1: PropTypes.string,
    thumbs: PropTypes.array,
    text2: PropTypes.string,
  };

  render() {
    const { photo, text1, thumbs, text2 } = this.props;

    return (
      <Styled data-test="featured">
        <Container>
          {photo && (
            <StyledRow>
              <StyledMedia {...photo} sizeContainer />
            </StyledRow>
          )}
          {text1 && (
            <StyledRow>
              <IndentSmall>
                <Text dangerouslySetInnerHTML={{ __html: text1 }} />
              </IndentSmall>
            </StyledRow>
          )}
          {thumbs &&
            thumbs.length > 1 && (
              <StyledRow>
                <StyledCol size={4}>
                  <StyledMedia {...thumbs[0]} sizes={[`${toVw(COL_SIZES[4])}`]} />
                </StyledCol>
                <StyledCol size={3}>
                  <StyledMedia {...thumbs[1]} sizes={[`${toVw(COL_SIZES[3])}`]} />
                </StyledCol>
              </StyledRow>
            )}
          {text2 && (
            <StyledRow>
              <IndentSmall>
                <Text dangerouslySetInnerHTML={{ __html: text2 }} />
              </IndentSmall>
            </StyledRow>
          )}
        </Container>
      </Styled>
    );
  }
}

export default FeaturedHome;



// WEBPACK FOOTER //
// ./src/scenes/Home/components/FeaturedHome/index.js